import React from "react";

import {Link} from "react-router-dom";

import ReactTable from "react-table";
import {Button} from "reactstrap";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PropTypes from "prop-types";
import {confirmAlert} from "react-confirm-alert";
import API from "@beardeddevops/react.api";
import CollectionOverride from "components/CollectionOverride";

export default class BoundBooks extends CollectionOverride {
	static propTypes = {
		...Framework.Components.Collection.propTypes,
		kioskMode: PropTypes.any,
	};

	constructor(props) {
		super(props, Types.Bound_Books._name);

		this.flagsModel = new API.BuildClass(Types.Locations_Bound_Books_Flags._name, API.RequestType.READ);

		this.doingFor = null;
		this.doingForBinary = null;
		this.state.flag_message = '';
		this.state.searchField = 'serial_number';

		this.tableStorageName = this.constructor.name + props.parent + '-' + props.id;
	};

	async componentDidUpdate (prevProps, prevState, snapshot) {
		this.tableStorageName = this.constructor.name + this.props.parent + '-' + this.props.id;
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (prevState.flag_message !== this.state.flag_message) {
			this.processFlag(null);
		}
		if(window.localStorage.getItem('firearm_trace') !== null && window.localStorage.getItem('firearm_trace') !== this.state.search) {
			let myItem = window.localStorage.getItem('firearm_trace');
			await this.setState({search: myItem});
		}
		if(this.state.data.length > 0 && window.localStorage.getItem('firearm_trace') !== null) {
			window.localStorage.removeItem('firearm_trace');
		}
	}

	setFlagMessage = (event) => {
		this.setState({[event.target.name]: event.target.value});
	};

	processFlag = (event) => {
		// if (event && event.target) {
		let serial = null;
		let manufacturer = null;
		let caliber = null;
		let model = null;
		let type = null;
		let status = null;

		//these values get overwritten when the <Textfield/> calls it's onchange prop below.
		// so I saved them in state to preserve values
		if(event && event.target) {
			this.doingFor = parseInt(event.target.getAttribute('data-id'));
			this.doingForBinary = event.target.getAttribute('data-binary-id');
			serial = event.target.getAttribute('data-serial');
			caliber = event.target.getAttribute('data-caliber');
			manufacturer = event.target.getAttribute('data-manufacturer');
			model = event.target.getAttribute('data-model');
			type = event.target.getAttribute('data-type');
			status = event.target.getAttribute('data-status');
			this.setState({
				mySerial: serial,
				myCaliber: caliber,
				myManufacturer: manufacturer,
				myModel: model,
				myType: type,
				myStatus: status
			})
		}
		confirmAlert({
			closeOnClickOutside: false,
			customUI: ({onClose}) => {
				return (
					<div className="react-confirm-alert">
						<div className="react-confirm-alert-body">
							<h1>Additional Details</h1>

							<TextField
								fullWidth
								margin="dense"
								variant="outlined"
								name="flag_message"
								placeholder="Details / Explanation"
								value={this.state.flag_message}
								onChange={this.setFlagMessage}
							/>

							<div style={{justifyContent: 'flex-end'}} className="react-confirm-alert-button-group">
								<div>
									<button onClick={() => {
										this.doingFor = null;
										this.doingForBinary = null;
										this.state.flag_message = '';
										onClose();
									}} style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-default'}>Cancel
									</button>
									<button onClick={() => {
										this.submitFlag();
										onClose();
									}} style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-success'}>
										Save
									</button>
								</div>
							</div>
						</div>
					</div>
				);
			}
		});
		// }
	};

	submitFlag = () => {
		//BoundBook
		this.flagsModel.parent = this.props.id || null;
		//FLagged Product Information
		this.flagsModel.grandparent = this.props.parent;
		this.flagsModel.object.transaction_entry = this.doingFor;
		this.flagsModel.object.transaction_entry_binary_id = this.doingForBinary;
		this.flagsModel.object.note = this.state.flag_message;
		this.flagsModel.object.manufacturer_other = this.state.myManufacturer
		this.flagsModel.object.caliber_other = this.state.myCaliber;
		this.flagsModel.object.serial_number = this.state.mySerial;
		this.flagsModel.object.model = this.state.myModel
		this.flagsModel.object.gun_type = this.state.myType;
		this.flagsModel.object.status = this.state.myStatus;
		this.flagsModel.object.date = new Date();
		this.flagsModel.submit(null, API.RequestType.CREATE).then(() => {
			this.doingFor = null;
			this.doingForBinary = null;
			this.serial = null;
			this.manufacturer = null;
			this.caliber = null;
			this.state.flag_message = '';
		});
		return false;
	}

	handleSelectPropertyUpdate = (property, value, linked, object) => {
		if (linked) {
			if (object && object.hasOwnProperty('binary_id')) {
				this.setState({
					[linked]: object,
					[property]: value,
					[property + '_error']: '',
					[property + '_binary_id']: object.binary_id,
					[property + '_binary_id_error']: '',
				});
			} else {
				this.setState({
					[linked]: object,
					[property]: value,
					[property + '_error']: '',
				});
			}
		} else {
			this.setState({
				[property]: value,
				[property + '_error']: '',
			});
		}
	};

	processQueue = (filtered) => async () => {
		this.setState({loading: true});

		let bbQueueModel = new API.BuildClass(Types.Locations_Bound_Books_Queues._name, API.RequestType.READ);

		bbQueueModel.parent = this.props.id ? this.props.id : 0;
		bbQueueModel.grandparent = this.props.parent;

		if (filtered) {
			bbQueueModel.object.date_start = this.state.startDate;
			bbQueueModel.object.date_end = this.state.endDate;
			if (this.state.filterStatus) {
				if (this.state.filterStatus.value === 1) {
					bbQueueModel.object.entries = 'O';
				}
				if (this.state.filterStatus.value === 2) {
					bbQueueModel.object.entries = 'C';
				}
			}
			bbQueueModel.object.search = this.state.search;
			bbQueueModel.object.search_field = this.state.searchField ? this.state.searchField['value'] : '';
			bbQueueModel.object.sort = this.model.sort;
			bbQueueModel.object.sort_order = this.model.order;
		}
		let result;
		try {
			result = await bbQueueModel.submit(null, API.RequestType.CREATE);
		} catch (e) {

		}

		this.setState({loading: false});

		// if( this.props.id ) {
		// 	this.props.history.push('/locations/' + this.props.parent + '/' + this.props.id + '#downloads' );
		// } else {
		// 	this.props.history.push('/locations/' + this.props.parent + '#downloads' );
		// }
		if (this.props.handleTabChange && result !== undefined) {
			this.props.handleTabChange(null, 'downloads')
		} else {
			this.props.reloadPage();
		}
	}

	render() {

		const {data, pages, limit, loading} = this.state;
		const extraColumns = [
			{
				Header: 'Acquisition ID',
				accessor: 'transaction_in_id',
				// show: !!this.state['column_transaction_in_id'],
				toggle: 'column_transaction_in_id'
			},
			{
				Header: 'Disposition ID',
				accessor: 'transaction_out_id',
				show: !!this.state['column_transaction_out_id'],
				toggle: 'column_transaction_out_id'
			},
			{
				Header: 'Disposition ID Override',
				accessor: 'manual_4473',
				show: !!this.state['column_manual_4473'],
				toggle: 'column_manual_4473'
			}
		];

		const columns = [
			...this.props.kioskMode ? [{
				Header: "For IOI",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 80,
				/** @param {Bound_Books_Object} props.original */
				Cell: props => {
					return (
						<span>
							{props.original.transaction_in &&
							<Button onClick={this.processFlag}
							        data-serial={props.original.serial_number} data-manufacturer={props.original.manufacturer} data-model={props.original.model}
							        data-caliber={props.original.caliber} data-binary-id={props.original.transaction_out_binary_id} data-id={props.original.transaction_out}
							        data-type={props.original.type} data-status={props.original.status}
							        color="warning"
							        size={"sm"}
							        block={true}
							>Flag</Button>}
						</span>
					);
				}
			}] : [],
			{
				Header: "Product",
				columns: [
					{
						Header: 'Manufacturer',
						accessor: 'manufacturer',
					},
					{
						Header: 'Model',
						accessor: 'model',
					},
					{
						Header: 'Type',
						accessor: 'type',
					},
					{
						Header: 'Caliber',
						accessor: 'caliber',
					},
					{
						Header: 'Serial',
						accessor: 'serial_number',
					},
					{
						Header: 'Notes',
						accessor: 'item_description',
					},
				],
			},
			{
				Header: "Acquired",
				columns: [
					extraColumns[0],
					{
						Header: 'Date In',
						id: 'date_in',
						/** @param {Bound_Books_Object} obj */
						accessor: obj => moment(obj.date_in)
							.local()
							.format("MM/DD/YYYY"),
					},
					{
						Header: 'From',
						id: 'in_from',
						/** @param {Bound_Books_Object} obj */
						accessor: obj =>
							obj.importer_name ? obj.importer_name : (obj.in_from_type === 'dealer' || obj.in_from_type === 'location') ? (obj.in_from + ' (' + obj.in_from_ffl + ')') : obj.in_from
					}
					, this.props.rootState.hasImporterModule &&
						{
							Header: 'Country Of Origin',
							id: 'country_of_origin',
							/** @param {Bound_Books_Object} obj */
							accessor: obj => obj.country_of_origin
						}
				]
			},
			{
				Header: "Disposed",
				columns: [
					extraColumns[1],
					extraColumns[2],
					{
						Header: 'Date Out',
						id: 'date_out',
						/** @param {Bound_Books_Object} obj */
						accessor: obj => obj.date_out && moment(obj.date_out)
							.local()
							.format("MM/DD/YYYY"),
					},
					{
						Header: 'To',
						id: 'out_to',
						/** @param {Bound_Books_Object} obj */
						accessor: obj =>
							obj.out_to ?
								(obj.out_to_type === 'dealer' ?
									(obj.out_to + ' (' + obj.out_to_ffl + ')') : obj.incident_number ?
										obj.out_to + ' - ' + obj.incident_number
										: obj.out_to)
								: obj.out_to
					},
					{
						Header: 'Address',
						id: 'out_to_address',
						/** @param {Bound_Books_Object} obj */
						accessor: obj =>
							obj.out_to_address && obj.out_to_address + ' ' + obj.out_to_location
					}
				]
			},
			{
				Header: "NICS",
				accessor: 'nics'
			},
			...!this.props.kioskMode ? [{
				Header: "A",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				/** @param {Bound_Books_Object} props.original */
				Cell: props => {
					return (
						<span>
							{props.original.transaction_in &&
							<Link to={`/acquisitions/${props.original.transaction_in_binary_id}-${props.original.transaction_in}`}>
								<Tooltip title={'Acquisition'} placement={'top-end'}>
									<Button color="green-meadow" size="sm" block={true}>
										<i className="fa fa-download"/>
									</Button>
								</Tooltip>
							</Link>}
						</span>
					);
				}
			}] : [],
			{
				Header: "D",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				/** @param {Bound_Books_Object} props.original */
				Cell: props => {
					return (
						<span>
							{props.original.status === 'Sold' &&
							<Link to={`/dispositions/${props.original.transaction_out_binary_id}-${props.original.transaction_out}`}>
								<Tooltip title={'Disposition'} placement={'top-end'}>
								<Button  color="green-meadow" size="sm" block={true} >
									<i className="fa fa-upload"/>
								</Button>
							</Tooltip>
							</Link>}
							{props.original.status === 'Lost / Stolen' &&
								<Link to={`/losses/${props.original.transaction_out_binary_id}-${props.original.transaction_out}`}>
									<Tooltip title={'Loss/Stolen'} placement={'top'}>
										<Button color="green-meadow" size="sm" block={true}>
											<i className="fa fa-upload"/>
										</Button>
									</Tooltip>
								</Link>
							}
						</span>
					);
				}
			},
		];
		const {expanded, columnsAnchor} = this.state;
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearchFields(columns)}
							{this.renderSearch('Bound Books', "")}
							{this.renderStatusFilter()}
							{this.renderDateRangeSearch()}
							<Framework.Components.TableHeaderRight
								name="Bound Books"
								csvData={this.downloadData(columns)}
								onReload={this.reloadTable}
								onClear={this.clearFilters}
							><Tooltip title={'Print Filtered Bound Book Download'} placement={"top"}>
								<Button color="primary" onClick={this.processQueue(true)} style={{marginLeft: '4px'}}>
									<i className="fa fa-print"/>
									<span className="truncatedText">Filtered</span>
									<span className="fullText">Filtered</span>
								</Button>
							</Tooltip>
								<Tooltip title={'Print Legal Bound Book Download'} placement={"top"}>
									<Button color="primary" onClick={this.processQueue(false)} style={{marginLeft: '4px'}}>
										<i className="fa fa-print"/>
										<span className="truncatedText">Legal</span>
										<span className="fullText">Legal</span>
									</Button>
								</Tooltip>
								{extraColumns && <div className="">
									{extraColumns.length > 0 &&

									<Button color="secondary"
									        outline={true}
									        aria-owns={columnsAnchor ? 'quick-transactions' : null}
									        aria-haspopup="true"
									        onClick={this.handleOpen('columnsAnchor')}
									        style={{marginLeft: '4px'}}
									>
										<i className={"fa fa-bars"}/>
									</Button>
									}
									{extraColumns.length > 0 &&
									<Menu
										id="quick-transactions"
										anchorEl={columnsAnchor}
										open={Boolean(columnsAnchor)}
										onClose={this.handleClose}
										getContentAnchorEl={null}
										anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
										transformOrigin={{horizontal: 'left', vertical: 'top'}}
									>
										{extraColumns.map((col, i) => {
											return (
												<MenuItem key={i} onClick={this.toggleColumn(col)}>
													<ListItemIcon>
														<i className={this.state[col.toggle] ? 'fa fa fa-check-square-o fa-lg' : 'fa fa-square-o fa-lg'}/>
													</ListItemIcon>
													<ListItemText inset primary={col.Header}/>
												</MenuItem>
											)
										})}
									</Menu>}
								</div>}
							</Framework.Components.TableHeaderRight>
						</div>
					</div>
					<Framework.Errors.General isDev={!process.env.production}>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
							className="-striped -highlight"
						/>
					</Framework.Errors.General>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
